module.exports = __webpack_public_path__ + "static/reception.3eb88b4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/reception.png
// module id = 103
// module chunks = 104101334113578 114276838955818